@import '../styles/palette.scss';

.page {
  .praksisstederHeader {
    border-bottom: 1px solid grey;
    font-size: large;
    margin-top: 8px;
    padding: 8px;
  }

  .numPlacesText {
    float: right;
    font-size: large;
    margin: 12px;
  }

  .numPlaces {
    border: 1px solid grey;
    border-radius: 5px;
    margin-left: 12px;
    padding: 8px 16px;
  }

  .topLevelNodeRow .praksisstedName {
    font-size: larger;
    font-weight: 600;
  }

  .topLevelNodeRow {
    background-color: _palette(praksissteder-aktivitetskrav-bg-topnode);
    border-bottom: 1px solid grey;
    border-top: 1px solid grey;

    &.hasChildNodes {
      .node {
        cursor: pointer;
      }
    }

    .node {
      position: relative;

      .toggleExpand {
        left: 4px;
        position: absolute;
        top: 8px;
      }

      .praksisstedName {
        margin: 10px 0 0 34px;
      }
    }

    &:last-child {
      border-bottom: 2px solid grey;
    }
  }

  .middleNode {
    background-color: _palette(praksissteder-aktivitetskrav-bg-middlenode2);
    border-top: 1px solid grey;

    svg {
      vertical-align: bottom;
    }

    input svg {
      vertical-align: top;
    }

    .node {
      cursor: pointer;
      margin-top: 10px;
      padding-left: 30px;
      position: relative;

      .toggleExpand {
        left: 4px;
        position: absolute;
      }
    }

    .indent1 {
      font-weight: 600;
    }
  }

  .middleNode1 {
    background-color: _palette(praksissteder-aktivitetskrav-bg-middlenode1);
  }

  .leafNode {
    background-color: _palette(praksissteder-aktivitetskrav-bg-leafnode);
    border-top: 1px solid grey;

    svg {
      color: grey;
      vertical-align: bottom;
    }

    input svg {
      vertical-align: top;
    }

    .node {
      margin-top: 10px;
      padding-left: 30px;
    }
  }

  a:focus img {
    border: 1px solid _palette(input-border-outlined);
    border-radius: 50%;
  }

  a:hover img {
    border: 1px solid _palette(input-border-primary);
    border-radius: 50%;
  }
}
